import { AmplitudeLogger } from '@/utilities/analyticsHelper';
import { EventNames } from '@/constants';

export const logErrorViewed = (
  logger: AmplitudeLogger,
  { message, stepName }: { message: string; stepName: string }
) => {
  logger({
    name: EventNames.ERROR_VIEWED,
    data: {
      message,
      step_name: stepName,
    },
  });
};
